<template>
    <section>
        <div class="row">
            <div class="col px-5">
                <div class="row justify-content-end align-items-center mt-5 mb-3">
                    <div class="col">
                        <h3 class="mb-0">
                            Program Studi {{ courseCategory.name }}
                        </h3>
                    </div>
                    <div class="col-auto ml-auto">
                        <form class="form-inline" v-on:submit.prevent="fetchData()">
                            <div class="row align-items-center">
                                <div class="col pr-1">
                                    <input v-model="form.keyword" class="form-control form-control-sm" placeholder="Search..." />
                                </div>
                                <div class="col-auto pl-1">
                                    <button type="submit" class="btn btn-danger btn-sm px-3">
                                        Search
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-lg-10 col-12 px-5">
                        <div class="row" v-for="(department, index) in departments">
                            <div class="col">
                                <b-button block variant="link" class="text-left text-danger" v-bind:pressed.sync="states[index]" v-b-toggle="'accordion-' + index">
                                    <div class="row justify-content-between align-items-center">
                                        <div class="col text-truncate h3 mb-0 font-weight-light">
                                            {{ department.name }}
                                        </div>
                                        <div class="col-auto">
                                            <i class="fa fa-lg" v-bind:class="states[index] ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'"></i>
                                        </div>
                                    </div>
                                </b-button>
                                <b-collapse v-model="states[index]" v-bind:id="'accordion-' + index">
                                    <div class="row align-items-end mt-4">
                                        <div class="col-xl-4 col-md-6 col-12 mb-4 px-4" v-for="course in department.courses">
                                            <img v-if="course.image" class="img-thumbnail rounded-circle mx-auto position-relative border-danger d-block" v-bind:src="course.imageUrl" />
                                            <div class="card shadow-sm mb-4 border-0">
                                                <div class="card-header background-primary">
                                                    <div class="row justify-content-end">
                                                        <div class="col">
                                                            &nbsp;
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-body">
                                                    <router-link v-bind:to="{ name: 'program-study/view', params: {type: courseCategory.id, id: course.id} }" class="font-weight-bold text-danger text-uppercase text-center h3 d-block">
                                                        {{ course.name }}
                                                    </router-link>
                                                    <div class="row">
                                                        <div class="col overflow">
                                                            <div v-html="course.description"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-collapse>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "ProgramStudyIndex",
        watch: {
            '$route.params.type'() {
                this.fetchData();
            }
        },
        data() {
            return {
                form: {
                    keyword: ''
                },
                courseCategory: {},
                departments: [],
                states: []
            };
        },
        methods: {
            fetchDepartment() {
                this.axios.get(process.env.API_URL + '/department', {params: Object.assign({}, this.form, {courseCategoryID: this.courseCategory.id})}).then(response => {
                    this.departments = response.data.data.filter(department => department.courses.length > 0);
                    this.states.fill(this.form.keyword !== '', 0, this.departments.length);
                });
            },
            fetchData() {
                this.axios.get(process.env.API_URL + '/course-category').then(response => {
                    this.courseCategory = response.data.data.find(courseCategory => courseCategory.id === parseInt(this.$route.params.type));
                    if (!this.courseCategory) {
                        this.$router.replace({name: 'error', params: {code: 404, message: 'Program Study not found'}});
                    }
                    this.fetchDepartment();

                    document.title = 'Prodi ' + this.courseCategory.name + ' - ' + process.env.APP_NAME;
                });
            }
        },
        created() {
            this.fetchData();
        }
    };
</script>

<style scoped>
    .overflow{ max-height: 90px; overflow-y: hidden; }
</style>


// WEBPACK FOOTER //
// src/components/program-study/Index.vue